import React from 'react';
import { Target, Landmark, ClipboardCheck, Scale, Workflow, ShieldCheck } from 'lucide-react';

const DIFFERENTIATORS = [
  {
    id: 'structuring-led',
    icon: Target,
    title: 'Structuring-Led Approach',
    description: 'We begin with the requirement — not a predetermined product. Financial assessment of cash flows, leverage, collateral and funding objectives comes before any institution is approached.'
  },
  {
    id: 'multi-institution',
    icon: Landmark,
    title: 'Multi-Institution Access',
    description: 'Financing possibilities are evaluated across banks, NBFCs, financial institutions and other appropriate capital providers — not a single lender relationship.'
  },
  {
    id: 'financial-assessment',
    icon: ClipboardCheck,
    title: 'Financial Assessment',
    description: 'Cash flows, leverage, collateral, repayment capability and funding objectives are understood in depth before structuring the capital requirement.'
  },
  {
    id: 'commercial-negotiation',
    icon: Scale,
    title: 'Commercial Negotiation',
    description: 'Pricing, security, tenure, covenants and structural flexibility are compared and negotiated across institutions on every mandate.'
  },
  {
    id: 'end-to-end-execution',
    icon: Workflow,
    title: 'End-to-End Execution',
    description: 'Experience across conventional and structured financing requirements — coordinated from initial assessment through sanction and financial closure.'
  },
  {
    id: 'senior-led',
    icon: ShieldCheck,
    title: 'Senior-Led & Confidential',
    description: 'Direct senior involvement throughout critical stages of the transaction, with sensitive financial information handled with discretion.'
  }
];

export const WhyChooseUs = () => {
  return (
    <section className="py-24 bg-white" data-testid="why-loanyard">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            Why <span className="text-emerald-600">LOANYARD CAPITAL</span>
          </h2>
          <p className="text-xl text-slate-600">
            An advisory-led practice built around structuring, institutional access and disciplined execution
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {DIFFERENTIATORS.map((benefit) => {
            const Icon = benefit.icon;
            return (
              <div 
                key={benefit.id} 
                className="group p-8 bg-slate-50 hover:bg-white rounded-2xl border border-transparent hover:border-emerald-500 hover:shadow-[0_4px_16px_rgba(15,23,42,0.08)] transition-all duration-300"
                data-testid={`why-${benefit.id}`}
              >
                <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-emerald-600 transition-colors duration-300">
                  <Icon className="w-7 h-7 text-emerald-600 group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">{benefit.title}</h3>
                <p className="text-slate-600 leading-relaxed">{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
